import { EngineeringShot } from "@/components/product-shot/engineering-shot";
import { ENGINEERING_ANCHOR, ENGINEERING_OFFER, STARTING_PRICES } from "@/app/pricing/pricing-data";
import { DATA_LABEL_CLS, DISPLAY } from "@/components/editorial";
import { CtaArrow } from "@/components/editorial/cta-arrow";
import frame from "@/components/editorial/shot-frame.module.css";

/*
 * Forward-deployed engineering, as a band on the home (Archie, 2026-10-01:
 * "a compelling section ... advertising our forward deployed engineering
 * offering", as a new band). The offer in the pricing page's own words
 * (ENGINEERING_OFFER) and its day rate, beside the product: a sample
 * workspace's channel Feed over a fortnight with one of our engineers, so
 * the offer is seen as work a customer's team watches and takes part in.
 * The head is the About page's sentence, shortened.
 *
 * It sits before the start band: who works with you, then the two weeks
 * and what they cost.
 */

const INK_72 = "text-[color-mix(in_srgb,var(--theme-ink)_72%,transparent)]";
const INK_88 = "text-[color-mix(in_srgb,var(--theme-ink)_88%,transparent)]";

export function EngineeringBand() {
  return (
    <section id="engineering" className="scroll-mt-24 border-b border-dotted border-[var(--rule)] py-20">
      <div className="grid items-center gap-14 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)]">
        <div>
          <p className={`${DATA_LABEL_CLS} text-[var(--theme-accent-text)]`}>Forward-deployed engineering</p>
          <h2 style={DISPLAY} className={`${INK_88} mt-4 max-w-[17ch] text-[clamp(2.2rem,4vw,3.4rem)] leading-[1.02] font-semibold tracking-[-0.035em] text-balance`}>
            Our engineers work alongside your team.
          </h2>
          <p className={`mt-5 max-w-[48ch] ${INK_72} text-[1.05rem] leading-[1.65]`}>{ENGINEERING_OFFER.description}</p>
          <ol className="mt-10 list-none border-t border-[var(--rule)] p-0">
            {ENGINEERING_OFFER.benefits.map((benefit, index) => (
              <li key={benefit.title} className="grid grid-cols-[2.5rem_minmax(0,1fr)] gap-2 border-b border-[var(--rule)] py-4">
                <span className="pt-0.5 text-[0.8rem] font-semibold text-[var(--theme-accent-text)] tabular-nums">{String(index + 1).padStart(2, "0")}</span>
                <span>
                  <span style={DISPLAY} className={`block text-[1.05rem] leading-[1.3] font-semibold ${INK_88}`}>
                    {benefit.title}
                  </span>
                  <span className={`mt-1 block text-[0.93rem] leading-[1.55] ${INK_72}`}>{benefit.detail}</span>
                </span>
              </li>
            ))}
          </ol>
          <p className={`mt-6 text-[0.88rem] leading-[1.6] ${INK_72}`}>
            <span className={`font-semibold ${INK_88}`}>{STARTING_PRICES.engineeringDay} a day.</span> {ENGINEERING_OFFER.beyond}{" "}
            <a href={`/pricing#${ENGINEERING_ANCHOR}`} className="font-medium whitespace-nowrap text-[var(--theme-accent-text)] underline underline-offset-4">
              Add engineering days <CtaArrow />
            </a>
          </p>
        </div>
        {/* A phone's rows wrap longer than the frame holds: its foot fades there. */}
        <div className={`min-w-0 ${frame.fadeFootOnPhone ?? ""}`}>
          <EngineeringShot />
        </div>
      </div>
    </section>
  );
}
